import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';
import { rgbColorToString } from '../../components/colorPicker/colorPicker.helpers';
import { type TinyMapColorTileComponentProps } from './tinyMapColorTile.component';
import { TinyMapPlaceholderShape } from './tinyMapPlaceholder.component';

const getSize = (fill?: boolean) => fill ? '100%' : '90%';
const getBorderRadius = (shape?: TinyMapPlaceholderShape) =>
  shape === TinyMapPlaceholderShape.Circle ? '50%' : 4;

const centeredPositionStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export const colorTileStyle = ({ color, lineColor, lineWidth, fill, shape }: TinyMapColorTileComponentProps) => {
  const size = getSize(fill);

  return css({
    ...centeredPositionStyle,
    backgroundColor: rgbColorToString(color),
    border: lineColor ? `${lineWidth}px solid ${rgbColorToString(lineColor)}` : 'none',
    borderRadius: getBorderRadius(shape),
    boxSizing: 'border-box',
    height: size,
    width: size,
    zIndex: 1,
  });
};

export const placeholderStyle = (shape?: TinyMapPlaceholderShape) => css({
  borderRadius: getBorderRadius(shape),
});

export const outlineStyles = (
  { fill, shape, lineWidth }: { fill?: boolean; shape?: TinyMapPlaceholderShape; lineWidth: number }
) => (theme: Theme) => {
  const size = `calc(${getSize(fill)} - ${lineWidth}px)`;

  return css({
    ...centeredPositionStyle,
    border: `1px solid ${theme.shadowColors.primary}`,
    borderRadius: getBorderRadius(shape),
    boxSizing: 'border-box',
    height: size,
    width: size,
    zIndex: 2,
  });
};
